import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { color } from '@metro-ui/tokens/js';
import { fontStack } from '../utils/fontStack';
import { Lock } from '../icons/icons/Lock';
import { InputElement, TextareaElement } from './components/Element';
import { IconAction } from './components/IconAction';
function guardHandler(eventFunction) {
    return function (e) {
        if (eventFunction) {
            eventFunction(e, e.target.value);
        }
    };
}
export var Input = styled(React.forwardRef(function (_a, ref) {
    var id = _a.id, _b = _a.type, type = _b === void 0 ? 'text' : _b, name = _a.name, isTextarea = _a.isTextarea, Icon = _a.Icon, _c = _a.iconPosition, iconPosition = _c === void 0 ? 'right' : _c, _d = _a.iconLabel, iconLabel = _d === void 0 ? 'Default label' : _d, onIconClick = _a.onIconClick, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onBeforeChange = _a.onBeforeChange, onChange = _a.onChange, hasInfo = _a.hasInfo, hasError = _a.hasError, isValid = _a.isValid, triggerInputPulseAnimation = _a.triggerInputPulseAnimation, isReadOnly = _a.isReadOnly, isRequired = _a.isRequired, isDisabled = _a.isDisabled, onBlur = _a.onBlur, onFocus = _a.onFocus, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["id", "type", "name", "isTextarea", "Icon", "iconPosition", "iconLabel", "onIconClick", "onKeyDown", "onKeyUp", "onBeforeChange", "onChange", "hasInfo", "hasError", "isValid", "triggerInputPulseAnimation", "isReadOnly", "isRequired", "isDisabled", "onBlur", "onFocus", "className", "children"]);
    var generateEventHandlers = function () { return ({
        onChange: function (e) {
            if (!onChange)
                return;
            if (onBeforeChange) {
                onChange(e, onBeforeChange(e.target.value));
            }
            else {
                onChange(e, e.target.value);
            }
        },
        onBlur: guardHandler(onBlur),
        onFocus: guardHandler(onFocus),
        onKeyUp: guardHandler(onKeyUp),
        onKeyDown: guardHandler(onKeyDown),
    }); };
    var LockOrIcon = isReadOnly ? Lock : Icon;
    var guardedIconPosition = isReadOnly ? 'left' : Icon && iconPosition;
    var renderInnerElement = function () {
        var props = __assign(__assign({}, htmlAttributes), { readOnly: isReadOnly, required: isRequired, disabled: isDisabled, id: id, type: type, name: name, isValid: isValid, hasInfo: hasInfo, hasError: hasError, ref: ref, hasAnimation: triggerInputPulseAnimation, iconPosition: guardedIconPosition });
        return isTextarea ? (React.createElement(TextareaElement, __assign({ isTextarea: true }, props, generateEventHandlers()))) : (React.createElement(InputElement, __assign({}, props, generateEventHandlers())));
    };
    return (React.createElement("div", { className: className },
        guardedIconPosition === 'left' && LockOrIcon && (React.createElement(LockOrIcon, { className: "m-input__icon--left" })),
        renderInnerElement(),
        children,
        guardedIconPosition === 'right' && Icon && (React.createElement(IconAction, { onClick: onIconClick, className: "m-input__icon--right", Icon: Icon, size: "medium", label: iconLabel, isDisabled: isDisabled, hasNoInteractionEffect: true }))));
}))(function (_a) {
    var isDisabled = _a.isDisabled, isReadOnly = _a.isReadOnly;
    var iconColor = color.palette.grey.tint[20];
    if (isDisabled && !isReadOnly)
        iconColor = color.disabled;
    else if (isReadOnly)
        iconColor = color.muted;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    position: relative;\n\n    .m-input__icon--left {\n      position: absolute;\n      top: 0;\n      left: 0.625rem;\n\n      height: 2.5rem;\n      width: 1.25rem;\n    }\n\n    .m-input__icon--left,\n    .m-input__icon--right:not(:focus) {\n      color: ", ";\n    }\n  "], ["\n    ", "\n    position: relative;\n\n    .m-input__icon--left {\n      position: absolute;\n      top: 0;\n      left: 0.625rem;\n\n      height: 2.5rem;\n      width: 1.25rem;\n    }\n\n    .m-input__icon--left,\n    .m-input__icon--right:not(:focus) {\n      color: ", ";\n    }\n  "])), fontStack, iconColor);
});
Input.propTypes = {
    id: PropTypes.string.isRequired,
    type: PropTypes.string,
    isTextarea: PropTypes.bool,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    isRequired: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    Icon: PropTypes.func,
    iconPosition: PropTypes.oneOf(['left', 'right']),
    iconLabel: PropTypes.string,
    isValid: PropTypes.bool,
    hasInfo: PropTypes.bool,
    hasError: PropTypes.bool,
    value: PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    onBeforeChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyUp: PropTypes.func,
    onKeyDown: PropTypes.func,
    onIconClick: PropTypes.func,
    className: PropTypes.string,
};
var templateObject_1;
//# sourceMappingURL=Input.js.map